<!--
  Forbrukerrådet - Kommunetesten
  @link https://gitlab01.copyleft.no/FBR/kommunetesten-new
  @author Anders Evenrud <anders.evenrud@copyleft.no>
-->
<template>
  <div class="view__home">
    <section class="filter-form">

      <template v-if="embedded">
        <Heading v-if="county">
          <Shield :county="county.id" :large="true" :title="county.name" />
          {{ county.name }}
        </Heading>

        <Heading :year="year" v-else>Plassering i Norge</Heading>
      </template>

      <template v-else>
        <Heading :year="year" v-if="county">
          <Shield :county="county.id" :large="true" :title="county.name" />
          {{ county.name }}
        </Heading>

        <Heading :year="year" v-else>
          Kommuneoversikt
        </Heading>

        <form method="get" action="">
          <fieldset class="filter-column">
            <Dropdown
              placeholder="Velg fylke"
              name="county"
              :items="countiesDropdown(year)"
              :value="String(county ? county.id : 0)"
              :key="String(county ? county.id : 0)"
              @onchange="onCountyChange" />
          </fieldset>

          <fieldset class="filter-column">
            <Dropdown
              placeholder="Velg år"
              name="year"
              :items="yearsDropdown"
              :value="String(year)"
              :key="String(year)"
              @onchange="onYearChange" />
          </fieldset>
        </form>
      </template>

    </section>

    <nav class="table">
      <Table :key="county ? county.id : 0"
        :county="county"
        :year="year"
        :rows="rows"
        :rowsPerPage="county ? 100 : 20"
        :infiniteScroll="true"
        @click="onTableClick" />
    </nav>
  </div>
</template>

<style lang="scss" scoped>
@import "../assets/variables";

.heading {
  /* This fixes pixel jumping when shield disappears */
  min-height: $shield-large-height;

  .shield {
    margin-right: 0.5em;
  }
}

section.filter-form {
  margin-bottom: 1em;

  & > .heading {
    flex: 1 1;
    margin-bottom: 0;

    img {
      padding-right: 0.5em;
    }
  }

  & > form {
    display: flex;
    align-items: center;

    & > fieldset {
      margin: 0;
      padding: 0;
      border: 0 none;
      flex: 1 1;
      min-width: 10em;

      &:first-child {
        margin-right: 0.5em;
      }

      &:last-child {
        margin-left: 0.5em;
      }
    }
  }
}

@media (max-width: $responsive-break) {
  section.filter-form {
    & > form {
      margin-top: 1em;

      .dropdown {
        min-width: auto;
      }
    }
  }
}

@media (min-width: $responsive-break) {
  section.filter-form {
    display: flex;
  }
}
</style>

<script>
import Table from '../components/Table.vue'
import Shield from '../components/Shield.vue'
import Heading from '../components/Heading.vue'
import Dropdown from '../components/Dropdown.vue'
import { mapGetters } from 'vuex'
import { EventBus } from '../bus.js'

export default {
  props: {
    year: Number,
    county: Object,
    municipality: Object,
    embedded: Boolean
  },

  components: {
    Table,
    Shield,
    Heading,
    Dropdown
  },

  computed: {
    ...mapGetters([
      'yearsDropdown',
      'countiesDropdown'
    ]),

    rows () {
      const cid = this.county ? this.county.id : null
      return this.$store.getters.municipalitiesByQuery(cid, this.year)
    }
  },

  methods: {
    onYearChange (ev, item) {
      const name = this.county ? 'county' : 'home'
      const params = this.county ? { fid: this.county.id } : {}
      const query = { year: item.value || '' }

      this.$router.push({ name, params, query })
    },

    onCountyChange (ev, item) {
      this.$router.push(this.countyLink(item.value, {
        year: this.year
      }))
    },

    onTableClick (ev, row) {
      const query = isNaN(this.year) ? {} : { year: this.year }
      const link = this.municipalityLink(row.kid, query)

      if (this.embedded) {
        EventBus.$emit('modal-open', row)
      } else {
        this.$router.push(link)
      }
    }
  }
}
</script>
